import {
  canonicalEventTypeForDisplay,
  extractPermissionStatusFromActivityData,
} from './activityEventLabels';
import { resolveActivityUserId } from './activityPayload';
import {
  isScreenViewLikeEvent,
  toReadableScreenName,
  resolveScreenNameFromActivityData,
} from './activityScreenLabels';

/**
 * WebSocket analytics:event / activity-update payload'larından
 * tek tip aktivite event objesi çıkarır (backend format farkları için).
 */
export function extractActivityEventFromSocketPayload(payload) {
  if (!payload || typeof payload !== 'object') return null;

  let raw = payload.event;
  if (!raw || typeof raw !== 'object') {
    if (payload.eventType || payload.action) {
      raw = payload;
    } else if (payload.data && typeof payload.data === 'object' && (payload.data.eventType || payload.data.action)) {
      raw = payload.data;
    } else {
      return null;
    }
  }

  const eventType =
    raw.eventType ??
    raw.action ??
    (typeof raw.type === 'string' &&
    raw.type !== 'ANALYTICS_EVENT' &&
    raw.type !== 'DASHBOARD_SYNC'
      ? raw.type
      : null) ??
    raw.data?.eventType ??
    raw.eventData?.eventType;

  if (!eventType || typeof eventType !== 'string') return null;

  const userId =
    raw.userId ??
    raw.user ??
    payload.userId ??
    raw.data?.userId ??
    raw.data?.identityNum ??
    raw.data?.tcNo ??
    raw.eventData?.userId;

  const timestamp =
    raw.timestamp ??
    raw.createdAt ??
    raw.created_at ??
    raw.time ??
    payload.timestamp;

  const id = raw.id ?? raw.activityId ?? payload.id ?? payload.activityId;

  return {
    ...raw,
    id,
    eventType: String(eventType).trim(),
    userId,
    timestamp,
  };
}

/** API / WS satırlarında mükerrer kontrolü */
export function activityRowFingerprint(row) {
  if (!row) return '';
  if (row.id) return String(row.id);
  const ts = new Date(row.timestamp || row.createdAt || 0).getTime();
  const bucket = Number.isFinite(ts) ? Math.floor(ts / 3000) : Date.now();
  const type = row.eventType || row.action || '';
  const user = row.userId || row.user || '';
  return `${type}-${user}-${bucket}`;
}

/**
 * Anlamsal (id'den bağımsız) tekilleştirme anahtarı.
 * Özellikle login/user_login ve aynı ekran görüntüleme tekrarlarını birleştirir.
 */
export function activitySemanticFingerprint(row) {
  if (!row) return '';

  const rawType = String(row.eventType || row.action || '').trim();
  const data = row.data || row;

  let normalizedType = canonicalEventTypeForDisplay(rawType);
  if (normalizedType === 'login' || normalizedType === 'signin') {
    normalizedType = 'user_login';
  } else if (isScreenViewLikeEvent(rawType, data)) {
    const screenRaw = resolveScreenNameFromActivityData(data, rawType) || rawType;
    normalizedType = `screen:${toReadableScreenName(screenRaw).toLowerCase()}`;
  }

  const user = String(resolveActivityUserId(row) || row.userId || row.user || '').trim();

  let bucketMs = 5000;
  const permissionKey = canonicalEventTypeForDisplay(rawType);
  if (
    user &&
    (permissionKey === 'location_permission_result' ||
      permissionKey === 'notification_permission_result')
  ) {
    const status = extractPermissionStatusFromActivityData(data) || 'unknown';
    normalizedType = `${permissionKey}:${status}`;
    bucketMs = 60000;
  }

  const ts = new Date(row.timestamp || row.createdAt || 0).getTime();
  const bucket = Number.isFinite(ts) ? Math.floor(ts / bucketMs) : Date.now();

  return `${normalizedType}-${user}-${bucket}`;
}
